import React from 'react';
import PropTypes from 'prop-types';
import { StyledSpinner } from './components/SpinnerStyles';

const Spinner = ({ size = 'sm', color, className = '' }) => {
  return (
    <StyledSpinner 
      className={`fas fa-sync-alt ${className}`.trim()} 
      size={size} 
      color={color} 
    />
  );
};

Spinner.propTypes = {
  size: PropTypes.oneOf(['xs', 'sm', 'md']),
  color: PropTypes.string,
  className: PropTypes.string,
};

Spinner.defaultProps = {
  size: 'sm',
  color: undefined,
  className: '',
};

export default Spinner;



// WEBPACK FOOTER //
// ./src/design-system/atoms/Spinner/Spinner.jsx